
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { I18nModule, ProductSearchPage, ProductSearchService, RoutingService } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { skip, Subscription, take } from 'rxjs';
import { QuoteProductListService } from '../product-list/core/quote-product-list.service';
import { QuoteSearchProductService } from '../_core/search-products.service';
import { loadingStatus, successStatus } from '../../../../../../core/models/request-status.model';
import { QuotesService } from '../../../core/quotes.service';
import { CustomValidatorService } from '../../../../../../components/form-elements/custom-validator.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'basic-search',
  standalone: true,
  imports: [ReactiveFormsModule, I18nModule, FormErrorsModule],
  templateUrl: './basic-search.component.html',
  styleUrl: './basic-search.component.scss',
})
export class BasicSearchComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  page$ = this.quoteSearchProductService.page$;
  clear$ = this.quotesService.clearBasicSearch$;

  form: UntypedFormGroup = this.fb.group({
    search: ['', [this.customValidator.required()]],
  });

  constructor(
    protected fb: UntypedFormBuilder,
    private productSearchService: ProductSearchService,
    private quoteProductListService: QuoteProductListService,
    private quoteSearchProductService: QuoteSearchProductService,
    private quotesService: QuotesService,
    private customValidator: CustomValidatorService,
    private activatedRoutesService: ActivatedRoute,
    private routingService: RoutingService,
  ) {}

  ngOnInit(): void {
    this.clearForm();
    this.checkPage();
    this.checkClear();
    this.testParams();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.productSearchService.clearResults();
    this.quoteProductListService.resetList();
  }

  testParams() {
    this.subscription.add(
      this.activatedRoutesService.queryParams.subscribe(params => {
        const partNumber = params['partNumber'];

        if (partNumber) {
          this.form.get('search')?.setValue(partNumber);
          this.submit();
        }
      }),
    );
  }

  checkClear() {
    this.subscription.add(
      this.clear$.subscribe(() => {
        this.clearForm();
      }),
    );
  }

  checkPage() {
    this.subscription.add(
      this.page$.pipe(skip(1)).subscribe(page => {
        this.submit(page);
      }),
    );
  }

  checkProducts(searchPage: ProductSearchPage) {
    this.quoteProductListService.showProducts$.next(true);
    this.quoteProductListService.setSearchResult({
      ...searchPage,
      ...successStatus,
    });
  }

  clearForm() {
    this.quoteProductListService.showProducts$.next(false);
    this.quoteProductListService.resetList();
    this.form.reset();
  }

  handlerSubmit() {
    const partNumber = this.form.get('search')?.value;
    this.routingService.go(['/quotes'], { queryParams: { partNumber } });
  }

  submit(page: number = 0) {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const query = this.form.get('search')?.value;

      this.quoteProductListService.setSearchResult(loadingStatus);
      this.quoteProductListService.showProducts$.next(true);

      this.quoteSearchProductService
        .get(query, {
          currentPage: page,
          searchQueryContext: 'FOR_QUOTES',
        })
        .pipe(take(1))
        .subscribe(searchPage => this.checkProducts(searchPage));
    }
  }
}
